"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var core_1 = require("@angular/core");
var common_1 = require("@angular/common");
var flex_layout_1 = require("@angular/flex-layout");
var forms_1 = require("@angular/forms");
var material_1 = require("@angular/material");
var core_2 = require("@ngx-translate/core");
var material_module_1 = require("../material.module");
var data_routing_module_1 = require("./data-routing.module");
var data_component_1 = require("./data.component");
var patient_data_component_1 = require("./patient/patient.data.component");
var current_status_component_1 = require("./current-status/current-status.component");
var patient_data_service_1 = require("../core/patient.data.service");
var data_graph_component_1 = require("../common/chart/linechart/data.graph.component");
var core_module_1 = require("../core/core.module");
var data_graph_component_2 = require("../common/chart/barchart/data.graph.component");
var common_module_1 = require("../common/common.module");
var device_data_component_1 = require("./device-data/device-data.component");
var export_data_component_1 = require("./export/export-data.component");
var view_data_component_1 = require("./view-data/view-data.component");
var DataModule = /** @class */ (function () {
    function DataModule() {
    }
    DataModule = tslib_1.__decorate([
        core_1.NgModule({
            imports: [
                common_1.CommonModule,
                core_module_1.CoreModule,
                core_2.TranslateModule,
                flex_layout_1.FlexLayoutModule,
                material_module_1.MaterialModule,
                material_1.MatPaginatorModule,
                forms_1.FormsModule,
                data_routing_module_1.DataRoutingModule,
                common_module_1.NanoCommonModule
            ],
            declarations: [
                data_component_1.DataComponent,
                patient_data_component_1.PatientDataComponent,
                current_status_component_1.CurrentStatusComponent,
                device_data_component_1.DeviceDataComponent,
                export_data_component_1.ExportDataComponent,
                view_data_component_1.ViewDataComponent
            ],
            exports: [
                data_routing_module_1.DataRoutingModule,
                data_component_1.DataComponent,
                patient_data_component_1.PatientDataComponent,
                data_graph_component_1.DataGraphComponent,
                data_graph_component_2.BarChartComponent,
                current_status_component_1.CurrentStatusComponent,
                device_data_component_1.DeviceDataComponent,
                view_data_component_1.ViewDataComponent
            ],
            providers: [
                patient_data_service_1.PatientDataService
            ]
        })
    ], DataModule);
    return DataModule;
}());
exports.DataModule = DataModule;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGF0YS5tb2R1bGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJkYXRhLm1vZHVsZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxzQ0FBeUM7QUFDekMsMENBQStDO0FBQy9DLG9EQUF3RDtBQUN4RCx3Q0FBNkM7QUFDN0MsOENBQXVEO0FBQ3ZELDRDQUFzRDtBQUV0RCxzREFBb0Q7QUFDcEQsNkRBQTBEO0FBQzFELG1EQUFpRDtBQUNqRCwyRUFBd0U7QUFDeEUsc0ZBQW1GO0FBQ25GLHFFQUFrRTtBQUNsRSx1RkFBb0Y7QUFDcEYsbURBQWlEO0FBQ2pELHNGQUFrRjtBQUNsRix5REFBMkQ7QUFDM0QsNkVBQTBFO0FBQzFFLHdFQUFxRTtBQUNyRSx1RUFBb0U7QUFxQ3BFO0lBQUE7SUFDQSxDQUFDO0lBRFksVUFBVTtRQW5DdEIsZUFBUSxDQUFDO1lBQ04sT0FBTyxFQUFFO2dCQUNMLHFCQUFZO2dCQUNaLHdCQUFVO2dCQUNWLHNCQUFlO2dCQUNmLDhCQUFnQjtnQkFDaEIsZ0NBQWM7Z0JBQ2QsNkJBQWtCO2dCQUNsQixtQkFBVztnQkFDWCx1Q0FBaUI7Z0JBQ2pCLGdDQUFnQjthQUNuQjtZQUNELFlBQVksRUFBRTtnQkFDViw4QkFBYTtnQkFDYiw2Q0FBb0I7Z0JBQ3BCLGlEQUFzQjtnQkFDdEIsMkNBQW1CO2dCQUNuQiwyQ0FBbUI7Z0JBQ25CLHVDQUFpQjthQUNwQjtZQUNELE9BQU8sRUFBRTtnQkFDTCx1Q0FBaUI7Z0JBQ2pCLDhCQUFhO2dCQUNiLDZDQUFvQjtnQkFDcEIseUNBQWtCO2dCQUNsQix3Q0FBaUI7Z0JBQ2pCLGlEQUFzQjtnQkFDdEIsMkNBQW1CO2dCQUNuQix1Q0FBaUI7YUFFcEI7WUFDRCxTQUFTLEVBQUU7Z0JBQ1AseUNBQWtCO2FBQ3JCO1NBQ0osQ0FBQztPQUNXLFVBQVUsQ0FDdEI7SUFBRCxpQkFBQztDQUFBLEFBREQsSUFDQztBQURZLGdDQUFVIn0=


//////////////////
// WEBPACK FOOTER
// ./src/app/data/data.module.ts
// module id = 621
// module chunks = 0